import { render, staticRenderFns } from "./DeleteAdmin.vue?vue&type=template&id=110eb1b8&scoped=true"
import script from "./DeleteAdmin.vue?vue&type=script&lang=js"
export * from "./DeleteAdmin.vue?vue&type=script&lang=js"
import style0 from "./DeleteAdmin.vue?vue&type=style&index=0&id=110eb1b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110eb1b8",
  null
  
)

export default component.exports